import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import { formatNumberToWan } from '@utils/formatNumber'
import classNames from 'classnames';
import UserMessageList from '@components/userMessageList';
import SystemList from '@components/systemList';
import MessageLikeAndFavoriteList from '@components/messageLikeAndFavoriteList';
import { px2rem } from '@utils/px2rem';
import { listenScrollDirection, getScrollPosition } from '@utils/scrollUtils';
import TabNav  from '@components/tabNav';

interface NotificationsListH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    navList?: any
    navClick?: Function
    navCurrentIndex?: any
    navCurrentType?: any
    loading?: boolean;
    hasMore?: boolean;
    handleLoadMore?: () => void;
}
interface NotificationsListH5State {
    loading: boolean;
    error: any
    pageLoaded: any
}
@inject('app', 'site', 'user', 'activity')
@observer
class NotificationsListH5Page extends BasePage<NotificationsListH5PageProps, NotificationsListH5State> {
    // 作为类属性直接定义
    scrollCleanup = null;
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };
    async componentDidMount() {
        const { app, user } = this.props;
        super.componentDidMount();
    }

    // 消息列表（评论和@）
    renderMessageList = () => {
        const { user, handleLoadMore, navCurrentIndex } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['userNotificationsList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'userNotificationsList' });
        console.log(flatList, '用户消息列表111111111111');
        return (
            <div style={{ marginBottom: 16 }}>
                <UserMessageList
                    data={flatList}
                    type={navCurrentIndex}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="userNotificationsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></UserMessageList>

            </div>
        )
    }

    // 消息的点赞和收藏列表
    renderLikeAndFavoriteList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) {
            return null;
        }
        const list = user.listStore.lists['userNotificationsList'];
        if (!list) {
            return null;
        }
        const flatList = user.listStore.getList({ namespace: 'userNotificationsList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <MessageLikeAndFavoriteList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="userNotificationsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></MessageLikeAndFavoriteList>
            </div>
        )
    }

    // 系统通知列表
    renderSystemList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['userNotificationsList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'userNotificationsList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <SystemList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="userNotificationsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></SystemList>
            </div>
        )
    }

    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }

    render() {
        const { navList, navCurrentIndex, navCurrentType } = this.props;
        const routerParams = new URLSearchParams(this.props.location.search);
        const tabParam = Number(routerParams?.get('tab')) || 0;
        return (<div className={styles.wrapper}>
            {/* 评论和@ */}
            {tabParam === 0 && <>
                <TabNav navList={navList} showRightCornerNum={true} currentIndex={navCurrentIndex} navClick={(item:any, index:any) => this.handleNavClick(item, index)} ></TabNav>
                {this.renderMessageList()}
            </>}
            {/* 系统通知 */}
            {tabParam === 1 && this.renderSystemList()}
            {/* 点赞和收藏 */}
            {tabParam === 2 && this.renderLikeAndFavoriteList()}
        </div>)
    }
}

export default withRouter(NotificationsListH5Page);
